import CartItems from '@activities/cart/CartActivity/components/CartItems';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import useCart from '@hooks/cart/useCart';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import usePrepareWithCart from '@store/cart/hooks/usePrepareWithCart';

import CartFooter from './components/CartFooter';
import CartNote from './components/CartNote';
import ShopLocation from './components/ShopLocation';

interface Params {
    shopId: string
}

const CartActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { shopId } = params;
  const cart = useCart(shopId);
  usePrepareWithCart(shopId);
  /*

  const shop = useShop(shopId);
  if (cart && shop && cart.items.length !== 0) {
    const orderLines: OrderLine[] = cart.items
      .map((cartItem) => ({
        status: cartItem.status,
        shopItemId: cartItem.itemId,
        itemName: cartItem.name,
        thumbnailImage: cartItem.thumbnailUrl,
        itemPrice: cartItem.salePrice,
        quantity: cartItem.qty,
        totalAmount: cartItem.salePrice * cartItem.qty,
        cartItemId: cartItem.cartItemId,
        itemImageUrl: cartItem.thumbnailUrl,
        couponUsable: cartItem.couponUsable,
        personalOptions: [],
        defaultOptions: [{
          optionGroupId: '',
          maxSelection: 10,
          minSelection: 0,
          options: cartItem.options.map((cartOption) => ({
            shopOptionId: cartOption.optionId,
            optionName: cartOption.name,
            optionPrice: cartOption.salePrice,
            quantity: cartOption.qty,
            totalAmount: cartOption.qty * cartOption.salePrice * cartItem.qty,
            maxQuantity: 10,
          })),
        }],
      }));

    const defaultValue: CreateOrderRequest = orderWithTotalAmount({
      projectId: '',
      shopId,
      shopName: shop.name,
      cartId: cart.cartId,
      orderPath: 'CART',
      orderType: 'IN_SHOP',
      orderLines,
      totalAmount: 0,
      paymentMethod: 'CREDIT_CARD',
      paymentAmount: 0,
      totalDiscount: 0,
      totalPointDiscount: 0,
      totalGiftDiscount: 0,
      totalCouponDiscount: 0,
      returnUrl: `${import.meta.env.VITE_BASE_URL}/purchase/complete`,
    });

  }

   */

  return (
        <AppScreen>
            <CtaLayout header={<Header title='장바구니' />}
                       footer={<CartFooter/>} >
                <ShopLocation/>
                {cart && (
                    <CartItems shopId={shopId}
                               cartId={cart.cartId} />
                )}
                <CartNote/>
            </CtaLayout>
        </AppScreen>
  );
  /*
  return (
        <AppScreen>
            <Header title='장바구니' />
            <BlankCart/>
        </AppScreen>
  );

   */
};

export default CartActivity;
